import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=3435235e&scoped=true&"
import script from "./Factura.vue?vue&type=script&lang=js&"
export * from "./Factura.vue?vue&type=script&lang=js&"
import style0 from "./Factura.vue?vue&type=style&index=0&id=3435235e&prod&lang=scss&"
import style1 from "./Factura.vue?vue&type=style&index=1&id=3435235e&prod&scoped=true&lang=css&"
import style2 from "./Factura.vue?vue&type=style&index=2&id=3435235e&prod&lang=scss&scoped=true&"
import style3 from "./Factura.vue?vue&type=style&index=3&id=3435235e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3435235e",
  null
  
)

export default component.exports